import { CacheProvider, ThemeProvider, ThemeProviderProps } from '@emotion/react';
import React from 'react';
import { cache } from './customEmotion';

export type EmotionProviderProps = ThemeProviderProps;

export const EmotionProvider = React.memo(({ children, theme }: EmotionProviderProps) => (
  <CacheProvider value={cache}>
    <ThemeProvider theme={theme}>{children}</ThemeProvider>
  </CacheProvider>
));
